import $ from 'jquery';
import slick from 'slick-carousel';


/* Global variables
********************************************/

var $breakpointSM = 576;



/* Sliders
********************************************/

$( document ).ready( function() {
	if ($('.js-slider-posts-mobile').length) {
		const settings = {
			mobileFirst: true,
			infinite: true,
			autoplay: false,
			adaptiveHeight: false,
			draggable: true,
			swipe: true,
			fade: false,
			variableWidth: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			dotsClass: 'c-slider__dots',
			arrows: false,
			nextArrow: '<a href="" class="c-slider__arrow c-slider__arrow--next"></a>',
			prevArrow: '<a href="" class="c-slider__arrow c-slider__arrow--prev"></a>',
			responsive: [
				{
					breakpoint: $breakpointSM - 1,
					settings: 'unslick'
				}
			]
		};

		$('.js-slider-posts-mobile').slick( settings );

		$( window ).on( 'resize orientationchange', function() {
			$('.js-slider-posts-mobile').each( function() {
				var $el = $( this );

				if ( $( window ).width() < $breakpointSM && ! $el.hasClass( 'slick-initialized' ) ) {
					$el.slick( settings );
				}
			} );
		} );
	}
} );


if ($('.js-gallery-slider').length) {
	$('.js-gallery-slider').slick({
		mobileFirst: false,
		infinite: false,
		autoplay: false,
		adaptiveHeight: true,
		draggable: true,
		swipe: true,
		fade: false,
		variableWidth: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		dotsClass: 'c-slider__dots',
		arrows: true,
		nextArrow: '<a href="" class="c-slider__arrow c-slider__arrow--large@xl c-slider__arrow--next"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/html/sprite/icons.svg#icon-chevron"></use></svg><svg class="c-slider__arrow-thin o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/html/sprite/icons.svg#icon-chevron-thin"></use></svg></a>',
		prevArrow: '<a href="" class="c-slider__arrow c-slider__arrow--large@xl c-slider__arrow--prev"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/html/sprite/icons.svg#icon-chevron"></use></svg><svg class="c-slider__arrow-thin o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/html/sprite/icons.svg#icon-chevron-thin"></use></svg></a>',
		//appendArrows: '.slick-list',
	});
}
